import Scrollbar from '@admin/components/scrollbar'
import Icon from '@admin/components/icon'
import PropTypes from 'prop-types'
import React from 'react'

class TermsField extends React.Component {

  static contextTypes = {
    locale: PropTypes.object,
    verify: PropTypes.object
  }

  static propTypes = {
    disabled: PropTypes.bool,
    defaultValue: PropTypes.bool,
    id: PropTypes.string,
    maxHeight: PropTypes.string,
    prompt: PropTypes.string,
    required: PropTypes.bool,
    tabIndex: PropTypes.number,
    terms: PropTypes.any,
    value: PropTypes.bool,
    onBusy: PropTypes.func,
    onChange: PropTypes.func,
    onReady: PropTypes.func,
    onValid: PropTypes.func
  }

  static defaultProps = {
    disabled: false,
    tabIndex: 0,
    value: false,
    onBusy: () => {},
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    checked: null,
    scrolled: false
  }

  _handleClick = this._handleClick.bind(this)
  _handleKeyPress = this._handleKeyPress.bind(this)
  _handleReachBottom = this._handleReachBottom.bind(this)
  _handleValidate = this._handleValidate.bind(this)

  render() {
    const { prompt, terms } = this.props
    const { t } = this.context.locale
    const { checked } = this.state
    if(checked == null) return null
    return (
      <div className={ this._getClass() }>
        <Scrollbar { ...this._getTerms() }>
          { terms }
        </Scrollbar>
        <div className="maha-termsfield-agree" onClick={ this._handleClick }>
          <div className="maha-termsfield-icon">
            <Icon { ...this._getInput() } />
          </div>
          { prompt &&
            <div className="maha-termsfield-prompt">
              <div dangerouslySetInnerHTML={{ __html: t(prompt) }} />
            </div>
          }
        </div>
      </div>
    )
  }

  _getTerms() {
    const { maxHeight } = this.props
    return {
      className: 'maha-termsfield-terms',
      maxHeight,
      onReachBottom: this._handleReachBottom
    }
  }

  componentDidMount() {
    const defaultValue = this._getDefaultValue()
    this._handleSet(defaultValue)
    this.props.onReady(this._handleValidate)
  }

  componentDidUpdate(prevProps, prevState) {
    const { checked } = this.state
    const { value } = this.props
    if(checked !== prevState.checked) {
      this._handleChange()
    }
    if(value !== prevProps.value) {
      this._handleSet(value)
    }
  }

  _getClass() {
    const { disabled } = this.props
    const { scrolled } = this.state
    const classes = ['maha-termsfield']
    if(disabled) classes.push('disabled')
    if(!scrolled) classes.push('disabled')
    return classes.join(' ')
  }

  _getDefaultValue() {
    const { defaultValue, value } = this.props
    return !_.isNil(value) ? value : !_.isNil(defaultValue) ? defaultValue : null
  }

  _getIcon() {
    return this.state.checked ? 'check-square' : 'square-o'
  }

  _getInput() {
    const { tabIndex } = this.props
    return {
      icon: this._getIcon(),
      tabIndex,
      onKeyPress: this._handleKeyPress
    }
  }

  _handleClick() {
    const { disabled } = this.props
    const { scrolled } = this.state
    if(disabled || !scrolled) return
    this._handleUpdate()
  }

  _handleChange() {
    const { checked } = this.state
    this.props.onChange(checked)
  }

  _handleKeyPress(e) {
    if (e.key !== ' ' && e.keyCode !== 32) return
    this._handleUpdate()
  }

  _handleReachBottom() {
    this.setState({ scrolled: true })
  }

  _handleSet(checked) {
    this.setState({ 
      checked: checked ?? false 
    })
  }

  _handleUpdate(checked = null) {
    const { disabled } = this.props
    if(disabled) return
    this._handleSet(checked ?? !this.state.checked)
  }

  _handleValidate() {
    const { checked } = this.state
    const { required, onValid } = this.props
    if(required && !checked) return onValid(null, ['This field is required'])
    onValid(checked)
  }

}

export default TermsField
